import { Action, Reducer } from "redux";
import { ValuatorActionTypes, ValuatorState, ValuatorTypes } from "./valuatorTypes";

export const INITIAL_STATE: ValuatorState = {
	valuators: {
		data: null,
		errorMessages: null,
		isError: false,
		isLoading: false,
	},
};

const valuatorReducer: Reducer<ValuatorState> = (state: ValuatorState = INITIAL_STATE, action: Action) => {
	const actionTypes = action as ValuatorActionTypes;
	switch (actionTypes.type) {
		case ValuatorTypes.GET_VALUATORS:
			return {
				...state,
				valuators: { ...state.valuators, isLoading: true },
			};
		case ValuatorTypes.SAVE_VALUATORS:
			return {
				...state,
				valuators: {
					...state.valuators,
					isLoading: false,
					errorMessages: actionTypes.payload.errorMessages,
					isError: actionTypes.payload.isError,
					data: actionTypes.payload.data,
				},
			};
		case ValuatorTypes.RESET_REDUCER_VALUATORS:
			return {
				...state,
				valuators: INITIAL_STATE.valuators,
			};
		default:
			return state;
	}
};

export default valuatorReducer;
